/** The one resource landing route sent from lesson emails, with no arbitrary return URL. */
export function isLessonResourceDestination(pathname: string): boolean {
  return /^\/lesson-resources\/(?:private|school)\/(?:[a-zA-Z0-9_-]|%[a-fA-F0-9]{2}){1,100}\/assets\/(?:[a-zA-Z0-9_-]|%[a-fA-F0-9]{2}){1,100}\/open$/.test(pathname);
}

export function navigateToLessonResource(url: string): void {
  window.location.replace(url);
}
